module.exports = __webpack_public_path__ + "img/jcb.2999f7fc.svg";